import { useEffect, useMemo, useState } from "react";
import { findThumbURL, findVideoURL } from "../../lib/media";

const useNubsVideoThumbnail = ({ key, data }) => {
  const { assets, liveAssetsId } = data;
  const thumb = useMemo(() => findThumbURL(assets, key), [assets, key]);
  const video = useMemo(() => findVideoURL(assets, key), [assets, key]);
  const [loaded, setLoaded] = useState(false);
  const error = useMemo(() => {
    // Error is always when the thumbnail failed to load
    return !loaded
  }, [loaded])

  useEffect(() => {
    if (liveAssetsId === key) {
      setLoaded(true)
    }
  }, [liveAssetsId, assets, key])

  return {
    errorState: [error],
    loadedState: [loaded, setLoaded],
    thumb,
    video,
  }
};

export default useNubsVideoThumbnail;
